import React from 'react'
import PasswordChecklist from 'react-password-checklist'
import { SlideDown } from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'
import './index.css'

interface PasswordChecklistIndicatorProps {
  value: string;
  valueAgain?: string;
  passwordChecklistStyle?: React.CSSProperties;
  onChange?: (isValid: boolean) => void;
  isPasswordFocused?: boolean;
  customStyles?: React.CSSProperties;
}

const PasswordChecklistIndicator: React.FC<PasswordChecklistIndicatorProps> = ({
  value,
  valueAgain,
  passwordChecklistStyle = {},
  onChange,
  isPasswordFocused,
  customStyles = {},
}) => {
  let wrapperClasses = 'passwordChecklist hidden-forever'
  if (isPasswordFocused) wrapperClasses = 'passwordChecklist'
  return (
    <SlideDown className="my-dropdown-slidedown" style={customStyles}>
      <PasswordChecklist
        className={wrapperClasses}
        value={value}
        valueAgain={valueAgain}
        onChange={onChange}
        style={passwordChecklistStyle}
        rules={['minLength', 'lowercase', 'capital', 'specialChar', 'number']}
        minLength={6}
        messages={{
          minLength: 'Password must have at least 6 characters.',
          lowercase: 'Password must have at least one lowercase character',
          capital: 'Password must have at least one capital letter.',
          specialChar: 'Password must have at least a special character',
          number: 'Password must have at least one number.',
        }}
        iconComponents={{
          ValidIcon: <div className="checkMarkListTab" />,
          InvalidIcon: <div className="checkMarkListInvalidTab" />,
        }}
      />
    </SlideDown>
  )
}

export default PasswordChecklistIndicator
